import { createFileRoute } from "@tanstack/react-router";
import { InferenceList, type InferenceSearch } from "../../features/inference/inference-list";

const SECTIONS = ["endpoints", "models"] as const;

export const Route = createFileRoute("/_authed/$org/$project/inference/")({
  validateSearch: (s: Record<string, unknown>): InferenceSearch => ({
    ...(SECTIONS.includes(s.section as never) ? { section: s.section as InferenceSearch["section"] } : {}),
    ...(typeof s.q === "string" && s.q ? { q: s.q } : {}),
    ...(typeof s.caps === "string" && s.caps ? { caps: s.caps } : {}),
    ...(typeof s.model === "string" && s.model ? { model: s.model } : {}),
  }),
  component: InferencePage,
});

function InferencePage() {
  const { org, project } = Route.useParams();
  return <InferenceList scope={{ org, project }} search={Route.useSearch()} />;
}
